module.exports = __webpack_public_path__ + "img/magento-setup-tuning.9cf149e1.webp";